<template>
    <div>
        <div style="display: flex; align-items: flex-end;">
            <kgr-department-select
                v-model="department"
                :club-id="clubId"
            />
            <kgr-text-input
                v-model="additionalInfo"
                :maxlength="50"
                style="margin-left: 10px"
                :label="$t('Zusätzliche Stichwörter')"
                :placeholder="$t('z.B. Team, Halle')"
            />
            <kgr-button
                :disabled="!department || generating"
                style="margin-left: 10px"
                @click="generate"
            >
                {{ $t('Bild generieren') }}
            </kgr-button>
        </div>
        <kgr-empty-data
            v-if="!department"
            :value="$t('Wähle eine Abteilung, um die generierten Bilder anzuzeigen.')"
            style="margin-top: 10px"
        />
        <kgr-empty-data
            v-if="department && !generating && departmentImages.length === 0"
            :value="$t('Für diese Abteilung wurden noch keine Bilder generiert.')"
            style="margin-top: 10px"
        />
        <div style="display: flex; flex-wrap: wrap; grid-gap: 10px; margin-top: 10px">
            <div
                v-if="generating"
                style="display: flex; align-items: center; justify-content: center; width: 448px; height: 256px; background-color: #f5f5f5; border: 1px solid #e0e0e0;"
            >
                <kgr-loading />
            </div>
            <div
                v-for="i in departmentImages"
                :key="i.hash"
                class="image-container"
                style="position: relative; width: 448px; height: 256px"
            >
                <img
                    :src="i.url"
                    style="width: 448px; height: 256px; object-fit: cover; position: absolute"
                    alt="department image"
                />
                <div class="controls">
                    <kgr-button
                        big
                        style="margin: 0 auto"
                        @click="useImage(i.hash)"
                    >
                        {{ $t('verwenden') }}
                    </kgr-button>
                    <kgr-button
                        type="red"
                        small
                        style="margin: 20px auto 0"
                        @click="deleteImage(i.hash)"
                    >
                        {{ $t('löschen') }}
                    </kgr-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AiAssistantRepository from '../../js/repository/AiAssistantRepository';
import DepartmentSelect from '../../components/common/form/select/DepartmentSelect.vue';
import EmptyData from '../../components/common/EmptyData.vue';
import KgrButton from '../../components/common/form/button/KgrButton.vue';
import Loading from '../../components/common/Loading.vue';
import TextInput from '../../components/common/form/text-input/TextInput.vue';

export default {
    components: {
        'kgr-button': KgrButton,
        'kgr-department-select': DepartmentSelect,
        'kgr-loading': Loading,
        'kgr-empty-data': EmptyData,
        'kgr-text-input': TextInput,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            department: null,
            additionalInfo: '',
            images: [],
            generating: false,
        };
    },
    computed: {
        departmentImages() {
            return this.images.filter(image => image.department.id === this.department?.id);
        },
    },
    async created() {
        const response = await AiAssistantRepository.findByClub(this.clubId);
        this.images = response.data;
    },
    methods: {
        async generate() {
            this.generating = true;
            const hash = Math.random().toString(36).substring(2, 15);
            await AiAssistantRepository.create(this.clubId, hash, this.department.id, this.additionalInfo);
            await this.fetchImage(hash);
        },
        async fetchImage(hash) {
            const response = await AiAssistantRepository.findDepartmentImage(this.clubId, hash);
            if (response.status === 204) {
                setTimeout(() => this.fetchImage(hash), 1000);
            } else {
                this.images.unshift({
                    url: response.url,
                    hash,
                    department: this.department,
                });
                this.generating = false;
            }
        },
        async useImage(hash) {
            await AiAssistantRepository.use(this.clubId, hash);
            this.$notify.success('Das Bild wurde erfolgreich zugewiesen');
        },
        async deleteImage(hash) {
            this.images = this.images.filter(image => image.hash !== hash);
            await AiAssistantRepository.delete(this.clubId, hash);
        },
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.controls {
    display: none;
    justify-content: center;
    position: absolute;
    width: 100%;
    height: 100%;
}
.image-container:hover .controls {
    display: flex;
    flex-direction: column;
    grid-gap: 10px;
}
</style>
